import PageRenderer from "../components/PageRenderer";

const Start = () => <PageRenderer pageName="Start" analyticsPath="/" />;

export default Start;
